import calendarService from "@/services/calendar.service";

const state = {
    calendarOptions: [
      {
        color: 'success',
        label: 'Påminnelser',
      },
      {
        color: 'danger',
        label: 'Familj',
      },
      {
        color: 'warning',
        label: 'Fritid',
      },
      {
        color: 'info',
        label: 'Övrigt',
      },
    ],
    selectedCalendars: ['Påminnelser', 'Familj', 'Fritid', 'Övrigt'],
    events: []
  }
  const mutations = {
    SET_SELECTED_EVENTS(state, val) {
      state.selectedCalendars = val
    },
    SET_EVENTS(state, events){
      state.events = events;
    },
    ADD_EVENT(state, event){
      state.events.push(event);
    },
    EDIT_EVENT(state, event){
      let eventIndex = state.events.findIndex(e => e.id == event.id);
      state.events[eventIndex] = event;
    }
  }
  const actions = {
    refetchEvents({dispatch}){
      dispatch('fetchEvents').then(response => {
        dispatch('setEvents', response);
      })
    },
    fetchEvents({state}) {
      return new Promise((resolve) => { 
        resolve(state.events)
      });    
    },  
    setEvents({commit}, events){
      commit('SET_EVENTS', events);
    },
    async addEvent({ rootGetters }, event) { 
      try {
        const response = await calendarService.add(event.event, rootGetters.getActivePortfolio);
        if (!response.data) {
          console.log("could not add event " + response);
        }
      } catch (error) {
        console.log(error);
      } 
    },
    async updateEvent(cxr, event) {    
      try {
        const response = await calendarService.update(event.event);
        if(response.data){
          return response.data;
        }else{
          console.log("could not update event " + response);
        }
      } catch (error) {
        console.log(error);
      }     
    },
   async removeEvent(cxr, event) {
      try {
        const response = await calendarService.delete(event.id);
        if(!response.data){
          console.log("could not delete event " + response);
        }
      } catch (error) {
        console.log(error);
      }  
    },
    clearCalendar({ commit }){
      commit("SET_EVENTS", [])
    } 
  }

  const getters = {}

export default {
  state,
  mutations,
  actions,
  getters
}